import React from 'react';
import styled from '@emotion/styled';
import { scVarTransitionDuration } from '@utils/emotion/variables';
import { useTranslation } from 'react-i18next';

const CardNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CardBlock className="card-item">
      <div className="inner">
        <div className="notice-item type-important">
          <h2 className="title">{t('home.notice.title')}</h2>
          <p className="desc">{t('home.notice.desc')}</p>
        </div>
        <div className="notice-item">
          <h2 className="title">{t('home.notice.law.title')}</h2>
          <p className="desc">{t('home.notice.law.desc')}</p>
        </div>
        <div className="notice-item">
          <h2 className="title">{t('home.notice.policy.title')}</h2>
          <p className="desc">{t('home.notice.policy.desc')}</p>
        </div>
      </div>
    </CardBlock>
  );
};

const CardBlock = styled.div`
  position: relative;
  width: 350px;
  padding: 22px 23px 22px 22px;
  background-color: ${({ theme }) => theme.colors.secondary.bgColor};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  transition: background-color ${scVarTransitionDuration} ease;
  color: #090909;

  .notice-item {
    border-bottom: 1px solid #c2cfe0;

    &.type-important {
      h2 {
        margin: 0;
        font-size: 18px;
      }

      .desc {
        margin-top: 17px;
      }
    }

    h2 {
      margin: 22px 0 11px;
      padding: 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.5;
      color: #090909;
      transition: color ${scVarTransitionDuration} ease;
    }

    .desc {
      font-size: 14px;
      color: #334d6e;
      word-break: keep-all;
    }
  }
`;

export default CardNotice;
